// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__PrZ7B","label":"LabeledBox_label__39a8G"};